import { render, staticRenderFns } from "./MyExams.vue?vue&type=template&id=0a1e2251&lang=pug&"
import script from "./MyExams.vue?vue&type=script&lang=js&"
export * from "./MyExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports